import { useMutation } from '@tanstack/react-query'
import { useApiClientUser } from '~/@api/client/useApiClientUser'
import type {
  ITwoFaVerifyOkResponse,
  ITwoFaVerifyRequest,
} from '~/@api/generated-api-types-user/Api'

export type LoginTwoFaRequest = Pick<ITwoFaVerifyRequest, 'code'>

function useLoginTwoFaMutation(
  twoFaSessionId: string | null,
  onSuccess: (data: ITwoFaVerifyOkResponse) => void
) {
  const { user } = useApiClientUser()

  const loginTwoFaMutation = useMutation({
    mutationFn: async (props: LoginTwoFaRequest) => {
      if (twoFaSessionId == null) throw new Error('Session ID is not available')

      return await user
        .authControllerVerifyTwoFaCode({
          code: props.code,
          sessionId: twoFaSessionId,
        })
        .then(({ data }) => data)
    },
    onSuccess,
  })

  return {
    loginUserTwoFa: loginTwoFaMutation.mutate,
    isRequesting: loginTwoFaMutation.isPending,
    error: loginTwoFaMutation.error,
    handleReset: loginTwoFaMutation.reset,
  }
}

export { useLoginTwoFaMutation }
